import React, { memo } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { AdministrationRoute, PrivateRoute } from 'common/AuthRoute';
import { BusinessPartnerMedicalOperatorsPage } from 'pages/BusinessPartnerManagement/BusinessPartnerMedicalOperatorsManagement/BusinessPartnerMedicalOperatorsPage';
import { BusinessPartnerMedicalOperatorPage } from 'pages/BusinessPartnerManagement/BusinessPartnerMedicalOperatorsManagement/BusinessPartnerMedicalOperatorPage';
import { BusinessPartnerMedicalOperatorsManagementRoutes } from 'pages/BusinessPartnerManagement/BusinessPartnerMedicalOperatorsManagement/businessPartnerMedicalOperatorsManagementRoues';
import { BusinessPartnerRegisterMedicalOperatorPage } from 'pages/BusinessPartnerManagement/BusinessPartnerMedicalOperatorsManagement/BusinessPartnerRegisterMedicalOperatorPage/index';

export const BusinessPartnerMedicalOperatorsManagement = memo(() => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <PrivateRoute
        exact
        path={path}
        component={BusinessPartnerMedicalOperatorsPage}
      />
      <AdministrationRoute
        exact
        path={`${path}/${BusinessPartnerMedicalOperatorsManagementRoutes.Register}`}
        component={BusinessPartnerRegisterMedicalOperatorPage}
      />
      <PrivateRoute
        exact
        path={`${path}/${BusinessPartnerMedicalOperatorsManagementRoutes.Details}`}
        component={BusinessPartnerMedicalOperatorPage}
      />
    </Switch>
  );
});
